module.exports = __webpack_public_path__ + "static/media/homepage-background.faee3606.jpg";